export default "/fonts/Muli-ExtraLightItalic.ttf?97d7c7420e10498ebc11160a9a67d615";